module.exports = __webpack_public_path__ + "static/media/milestone.aac68f22.svg";